/**
 * Coerces a value (possibly a backend/Formik error object) into something
 * safe to render as a React child. Prevents "Objects are not valid as a React child" runtime errors when a form receives an object-shaped error.
 *
 * @param {*} value
 * @returns {string|number}
 */
export const getSafeErrorText = value => {
  if (value === null || value === undefined || value === false) {
    return "";
  }
  if (typeof value === "string" || typeof value === "number") {
    return value;
  }
  if (typeof value === "object") {
    return value.message || value.error || "";
  }
  return "";
};
